import UnitSearchList from "components/common/dl_unit/UnitSearchList/UnitSearchList";

export default function UnitSearch() {
  return (
    <div>
      <UnitSearchList />
    </div>
  );
}
